import React, { useEffect } from "react";
import { useDrawer } from "../../hooks/useDrawer";
import cn from "../../lib/utils/class-name";
import { useLocation } from "react-router";

export default function GlobalDrawer() {
  const { isOpen, view, placement, containerClassName, closeDrawer } =
    useDrawer();
  const pathname = useLocation().pathname;
  useEffect(() => {
    closeDrawer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const shouldShow = isOpen ? "block" : "hidden";
  return (
    <div
      className={`fixed cursor-pointer animate-easeIn bg-black bg-opacity-20 top-0 left-0 w-full h-full z-[9999] backdrop-blur-[10px] ${shouldShow}`}
      onClick={closeDrawer}
    >
      <div
        className={cn(
          `absolute ${placement}-0 cursor-auto h-full bg-background transition-transform`,
          containerClassName
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {view}
      </div>
    </div>
  );
}
